/* components */
import { Typography, IconButton, MenuItem } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

import DataSaverOffIcon from "@mui/icons-material/DataSaverOff"
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined"
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined"
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined"
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts"
import PersonOutlineIcon from "@mui/icons-material/PersonOutline"
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck"
import PhonelinkIcon from "@mui/icons-material/Phonelink"
import NotificationsIcon from "@mui/icons-material/Notifications"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined"
import LockOpenIcon from "@mui/icons-material/LockOpen"
import logoME from "../../../../../../images/me.png"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
/* styles */
import useStyles from "./useStyles"
import { NavLink } from "react-router-dom"
import { useState } from "react"

function MoreSidebar({ closeSubMenu }) {
  const classes = useStyles()
  // const [anchorE1, setAnchorE1] = useState(null)
  const [showSubMenu, setShowSubMenu] = useState(false)
  const [showMenuSecurity, setShowMenuSecurity] = useState(false)
  const [openS, setOpenS] = useState(false)
  const [openME, setOpenME] = useState(false)

  const showIcon = (iconName) => {
    switch (iconName) {
      case "users":
        return <PersonOutlineIcon className={classes.icon} id={"activeIcon"} />
      case "suborganization":
        return <GroupsOutlinedIcon className={classes.icon} id={"activeIcon"} />
      case "storage/storage":
        return <DataSaverOffIcon className={classes.icon} id={"activeIcon"} />
      case "storage/recycle":
        return <DeleteOutlineIcon className={classes.icon} id={"activeIcon"} />
      case "ME/applicationInstances":
        return (
          <ManageAccountsIcon
            className={classes.iconSubItem}
            id={"activeIcon"}
          />
        )
      case "ME/import-cvs":
        return (
          <PlaylistAddCheckIcon
            className={classes.iconSubItem}
            id={"activeIcon"}
          />
        )
      case "ME/feacture-flags":
        return (
          <PhonelinkIcon className={classes.iconSubItem} id={"activeIcon"} />
        )
      case "security/file-extension":
        return (
          <InsertDriveFileOutlinedIcon
            className={classes.iconSubItem}
            id={"activeIcon"}
          />
        )
      case "security/cognito":
        return (
          <AdminPanelSettingsOutlinedIcon
            className={classes.icon}
            id={"activeIcon"}
          />
        )
      case "security":
        return (
          <SecurityOutlinedIcon className={classes.icon} id={"activeIcon"} />
        )
      case "globalNotification":
        return <NotificationsIcon className={classes.icon} id={"activeIcon"} />
      case "security/user-sessions":
        return (
          <LockOpenIcon className={classes.iconSubItem} id={"activeIcon"} />
        )
      case "ME/declarations":
        return (
          <ReceiptLongIcon className={classes.iconSubItem} id={"activeIcon"} />
        )
      case "ME/eventanilla":
        return (
          <EmailOutlinedIcon
            className={classes.iconSubItem}
            id={"activeIcon"}
          />
        )
      default:
        break
    }
  }

  const toggleSubMenu = () => {
    setOpenME(!openME)
    setShowSubMenu(!showSubMenu)
  }

  const toggleSubMenuSecurity = () => {
    setOpenS(!openS)
    setShowMenuSecurity(!showMenuSecurity)
  }
  const handleSubMenuClick = () => {
    closeSubMenu()
  }

  return (
    <div className={classes.container}>
      <CloseIcon
        className={classes.iconClose}
        sx={{ cursor: "pointer" }}
        onClick={handleSubMenuClick}
      />
      <IconButton sx={{ display: "flex", flexDirection: "row" }}>
        {showIcon("users")}
        <NavLink
          to={"users"}
          style={{ textDecoration: "none" }}
          onClick={handleSubMenuClick}
        >
          {/* <Box
            className={classes.containerIcon}
            id={'containerIconActive'}
            sx={{ cursor: 'pointer' }}
          >

          </Box> */}
          <Typography
            className={classes.title}
            id={"bold"}
            sx={{
              width: "200px",
              // marginTop: '20%',
              textAlign: "left",
              fontFamily: "Roboto",
              fontSize: 13,
              color: "#263057",
              marginLeft: "7%",

              "&:hover": {
                fontWeight: 700,
              },
            }}
          >
            {"Usuarios"}
          </Typography>
        </NavLink>
      </IconButton>
      <IconButton
        onClick={toggleSubMenu}
        sx={{ cursor: "pointer" }}
        id="submenu-icon"
      >
        <img
          src={logoME}
          style={{
            width: "16px",
            height: "16px",
            paddingLeft: "5px",
            // paddingTop: '20%'
          }}
        ></img>
        <Typography
          sx={{
            width: "70px",
            // marginTop: '20%',
            textAlign: "left",
            fontFamily: "Roboto",
            fontSize: 13,
            color: "#263057",
            marginLeft: 2,
            marginRight: 1,

            "&:hover": {
              fontWeight: 700,
            },
          }}
        >
          Mi Estudio
        </Typography>
        <KeyboardArrowDownIcon
          sx={{
            // ml: 2,
            transform: openME ? "rotate(-180deg)" : "rotate(0)",
            transition: "0.2s",
          }}
        />
      </IconButton>
      {openME && showSubMenu && (
        <div className={classes.containerSubMenu}>
          <MenuItem>
            {showIcon("ME/applicationInstances")}
            <NavLink
              to={"ME/applicationInstances"}
              style={{ textDecoration: "none", display: "flex" }}
              onClick={handleSubMenuClick}
            >
              <Typography
                className={classes.title}
                sx={{ marginTop: 1, marginLeft: 0.5 }}
              >
                Administrador de instancias
              </Typography>
            </NavLink>
          </MenuItem>

          <MenuItem>
            {showIcon("ME/import-cvs")}
            <NavLink
              to={"ME/import-cvs"}
              style={{ textDecoration: "none" }}
              onClick={handleSubMenuClick}
            >
              <Typography
                className={classes.title}
                sx={{ marginTop: 1, marginLeft: 0.5 }}
              >
                Habilitación de módulos
              </Typography>
            </NavLink>
          </MenuItem>

          <MenuItem>
            {showIcon("ME/feacture-flags")}
            <NavLink
              to={"ME/feacture-flags"}
              style={{ textDecoration: "none" }}
              onClick={handleSubMenuClick}
            >
              <Typography
                className={classes.title}
                sx={{ marginTop: 1, marginLeft: 0.5 }}
              >
                Control de versiones
              </Typography>
            </NavLink>
          </MenuItem>
          <MenuItem>
            {showIcon("ME/declarations")}
            <NavLink
              to={"ME/declarations"}
              style={{ textDecoration: "none" }}
              onClick={handleSubMenuClick}
            >
              <Typography
                className={classes.title}
                sx={{ marginTop: 1, marginLeft: 0.5 }}
              >
                Declaraciones
              </Typography>
            </NavLink>
          </MenuItem>
          <MenuItem>
            {showIcon("ME/eventanilla")}
            <NavLink
              to={"ME/eventanilla"}
              style={{ textDecoration: "none" }}
              onClick={handleSubMenuClick}
            >
              <Typography
                className={classes.title}
                sx={{ marginTop: 1, marginLeft: 0.5 }}
              >
                e-Ventanilla
              </Typography>
            </NavLink>
          </MenuItem>
        </div>
      )}
      <IconButton
        onClick={toggleSubMenuSecurity}
        sx={{ cursor: "pointer" }}
        id="submenu-icon"
      >
        {showIcon("security")}

        <Typography
          // className={classes.title}
          sx={{
            width: "150px",
            // marginTop: '25%',
            textAlign: "left",
            fontFamily: "Roboto",
            fontSize: 13,
            color: "#263057",
            marginLeft: 1.5,

            "&:hover": {
              fontWeight: 700,
            },
          }}
        >
          Sistema y seguridad
        </Typography>
        <KeyboardArrowDownIcon
          sx={{
            // ml: 2,
            transform: openS ? "rotate(-180deg)" : "rotate(0)",
            transition: "0.2s",
          }}
        />
      </IconButton>
      {openS && showMenuSecurity && (
        <div className={classes.containerSubMenu}>
          <MenuItem sx={{ width: 50 }}>
            {showIcon("security/file-extension")}
            <NavLink
              to={"security/file-extension"}
              style={{ textDecoration: "none" }}
              onClick={handleSubMenuClick}
            >
              <Typography
                className={classes.title}
                sx={{
                  marginTop: 1,
                  marginLeft: 0.5,
                }}
              >
                Administración de extensiones
              </Typography>
            </NavLink>
          </MenuItem>

          <MenuItem>
            {showIcon("security/cognito")}
            <NavLink
              to={"security/cognito"}
              style={{ textDecoration: "none" }}
              onClick={handleSubMenuClick}
            >
              <Typography
                className={classes.title}
                sx={{ marginTop: 1, marginLeft: 0.5 }}
              >
                Administración en cognito
              </Typography>
            </NavLink>
          </MenuItem>
          <MenuItem>
            {showIcon("security/user-sessions")}
            <NavLink
              to={"security/user-sessions"}
              style={{ textDecoration: "none" }}
              onClick={handleSubMenuClick}
            >
              <Typography
                className={classes.title}
                sx={{ marginTop: 1, marginLeft: 0.5 }}
              >
                Administración de sesiones
              </Typography>
            </NavLink>
          </MenuItem>
        </div>
      )}
      <IconButton
        sx={{ display: "flex", flexDirection: "row", marginTop: 0.5 }}
      >
        {showIcon("globalNotification")}
        <NavLink
          to={"globalNotification"}
          style={{ textDecoration: "none" }}
          onClick={handleSubMenuClick}
        >
          <Typography
            id={"bold"}
            sx={{
              width: "150px",
              // marginTop: '25%',
              textAlign: "left",

              fontFamily: "Roboto",
              fontSize: 13,

              color: "#263057",
              marginLeft: "7%",

              "&:hover": {
                fontWeight: 700,
              },
            }}
          >
            {"Notificaciones globales"}
          </Typography>
        </NavLink>
      </IconButton>
    </div>
  )
}
export default MoreSidebar
